/**
 * Shared session manager for super-app contexts (Toki, Hambi)
 * Handles localStorage persistence with expiration
 */

const TOKEN_EXPIRATION_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export const createSessionManager = (sessionKey) => ({
    save: (user, token) => {
        try {
            const session = {
                user,
                token,
                expiresAt: Date.now() + TOKEN_EXPIRATION_MS,
                createdAt: Date.now()
            };
            localStorage.setItem(sessionKey, JSON.stringify(session));
        } catch (e) {
            console.warn(`Failed to save ${sessionKey}:`, e);
        }
    },
    get: () => {
        try {
            const sessionStr = localStorage.getItem(sessionKey);
            if (!sessionStr) return null;

            const session = JSON.parse(sessionStr);

            if (session.expiresAt && Date.now() > session.expiresAt) {
                localStorage.removeItem(sessionKey);
                return null;
            }

            return { user: session.user, token: session.token };
        } catch (e) {
            console.warn(`Failed to get ${sessionKey}:`, e);
            return null;
        }
    },
    clear: () => {
        try {
            localStorage.removeItem(sessionKey);
        } catch (e) {
            console.warn(`Failed to clear ${sessionKey}:`, e);
        }
    }
});
